import { Button, Divider, FormControl, Image, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import React, { FormEvent } from 'react'

interface userSearchProps {
  userSearchText: string;
  setUserSearchText: (e: string) => void;
  handleSearch: (event: FormEvent) => void
}
export default function UserSearch({ userSearchText, setUserSearchText, handleSearch }: userSearchProps) {
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserSearchText(e.target.value)
  }
  return (
    <>
      <form onSubmit={handleSearch}>
        <FormControl whiteSpace={'nowrap'} padding={0}>
          <InputGroup className="input-group" maxWidth={'836px'}>
            <Input
              value={userSearchText}
              autoFocus
              placeholder={'Search by name or email...'}
              onChange={onChangeHandler}
              height={'55px'}
            />
            <InputRightElement
              width="4.5rem"
              className="input-right-element"
              alignItems={'center'}
            >
              <Divider
                orientation="vertical"
                className="input-right-divider"
              />
              <Button type={'submit'} size={'sm'} backgroundColor={'#FFFFFF'}>
                <Image src="/images/ui/searchIcon.svg"></Image>
              </Button>
            </InputRightElement>
          </InputGroup>
        </FormControl>
      </form></>
  )
}
